import { render, staticRenderFns } from "./ColorConversion.vue?vue&type=template&id=2cddfbc6&scoped=true"
import script from "./ColorConversion.vue?vue&type=script&lang=js"
export * from "./ColorConversion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cddfbc6",
  null
  
)

export default component.exports